import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib';

let styles = require('./RoomIcon.scss');

export interface RoomIconProps {
    backgroundColor: string;
}

/**
 * This is the room coin shown when displaying the room persona.
 */
export default class RoomIcon extends React.PureComponent<RoomIconProps, any> {
    render() {
        const coinBackgroundStyle = {
            backgroundColor: this.props.backgroundColor,
        };
        return (
            <div style={coinBackgroundStyle} className={styles.roomIconContainer}>
                <Icon iconName={ControlIcons.Room} className={styles.roomIcon} />
            </div>
        );
    }
}
